import React from "react";
import type { IUploadCodeAndSourceSelectionStore } from "./UploadCodeAndSourceSelectionStore";
import { injectFromAppUpload } from "../../inject";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import { SourceLogoComponent } from "../../../shared-components/source-logo/SourceLogoComponent";

interface IUploadCodeAndSourceSelectionValidatedComponentProps {
    uploadCodeAndSourceSelectionStore?: IUploadCodeAndSourceSelectionStore;
    resourcesStore?: IResourcesStore;
}

@injectFromAppUpload<IUploadCodeAndSourceSelectionValidatedComponentProps>(stores => ({
    uploadCodeAndSourceSelectionStore: stores.uploadCodeAndSourceSelectionStore,
    resourcesStore: stores.resourcesStore,
}))
@observer
export class UploadCodeAndSourceSelectionValidatedComponent extends React.Component<IUploadCodeAndSourceSelectionValidatedComponentProps> {
    render() {
        const { uploadCodeAndSourceSelectionStore, resourcesStore } = this.props;
        const { selectedSourceForUpload, uploadCodeAndSourceValid } = uploadCodeAndSourceSelectionStore!;
        const { resources } = resourcesStore!;

        if (!uploadCodeAndSourceValid || !selectedSourceForUpload) return;

        return (
            <div className={"validated-upload-code-and-source"}>
                <div className={"header"}>
                    <h3>
                        {resources.UploadPortal} <span>{selectedSourceForUpload.description}</span>
                    </h3>

                    <div className={"info"}>
                        {selectedSourceForUpload?.telephone && <div className={"telephone"}>{selectedSourceForUpload.telephone}</div>}
                        {selectedSourceForUpload?.email && <div className={"email"}>{selectedSourceForUpload.email}</div>}
                        <a className={"manual"} href={"/POW3/Resource/LocalHelpFile?manualsSection=Upload"} target="_blank" rel="noreferrer">
                            {resources.UploadManual}
                        </a>
                    </div>
                </div>
                <div className={"logo"}>
                    {selectedSourceForUpload?.logo && (
                        <SourceLogoComponent logo={selectedSourceForUpload.logo} logoStyle={selectedSourceForUpload.logoStyle} description={selectedSourceForUpload.description} />
                    )}
                </div>
            </div>
        );
    }
}
